import type { Courier } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface CourierInfoInput {
  id?: GQL_ID
  first_name: string
  last_name: string
  status: number
  phone: string
}

export interface SaveCourier {
  courier: Courier
}

export interface SaveCourierVariables {
  courierInfo: CourierInfoInput
  upsert: boolean
}

export const GQL_MUTATION_SAVE_COURIER = gql`
  mutation($courierInfo: CourierInfoInput, $upsert: Boolean) {
    courier: updateCourier(newData: $courierInfo, upsert: $upsert) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      shops {
        id
        name
        address
      }
      deliveryZones {
        id
        name
      }
      is_shift_require_confirmation
    }
  }
`

export const useMutateSaveCourier = () => {
  return useMutation<SaveCourier, SaveCourierVariables>(
    GQL_MUTATION_SAVE_COURIER
  )
}
